import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'clickableLinks',
  standalone: false,
})
export class ClickableLinksPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

    const replacedValue = value.replace(urlRegex, (originalUrl) => {
      let url = originalUrl;
      if (!originalUrl.match(/^(https?:\/\/)/)) {
        url = 'http://' + originalUrl;
      }

      return `<a href="${url}" target="_blank">${originalUrl}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
  }
}
